/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// react
import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import BASESvgIcon from "../../../../@BASE/core/BASESvgIcon";


const ViewSubheader = (props) => {
  const { data, action } = props;

  return (
    <div className="w-full mb-24 md:mb-0" role="presentation">
      <Breadcrumbs
        separator={<BASESvgIcon size={20} className={action === 'pre-trial-comments' ? 'text-black' : 'text-white'}>heroicons-solid:chevron-right</BASESvgIcon>}
        aria-label="breadcrumb"
      >
        {data.map((item, index) => (            
          <Link
            key={index}
            underline="hover"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: action === 'pre-trial-comments' ? '#000000 !important' : '#ffffff !important',
            }}
            href={item.path}
          >
            <BASESvgIcon size={20}>{item.icon}</BASESvgIcon>
            <span className="text-sm font-bold ml-4 mr-2">{item.label}:</span>
            <span className="text-sm">{item.value}</span>
          </Link>
        ))}
      </Breadcrumbs>
    </div>
  )
};

export default ViewSubheader;
